import { render, staticRenderFns } from "./custom-business-73.vue?vue&type=template&id=667929f5&scoped=true"
import script from "./custom-business-73.vue?vue&type=script&lang=js"
export * from "./custom-business-73.vue?vue&type=script&lang=js"
import style0 from "./custom-business-73.vue?vue&type=style&index=0&id=667929f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667929f5",
  null
  
)

export default component.exports